import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import '../../components/Navbar.css';
import AdminSidebar from '../../components/AdminSidebar';
import { getToken } from '../../utils/auth';

function VoterDetails() {
  const { voterId } = useParams();
  const [voter, setVoter] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVoter = async () => {
      try {
        const token = getToken();
        const res = await fetch(`/api/admin/voters/${voterId}`, { headers: { 'x-auth-token': token } });
        if (!res.ok) {
          throw new Error('Failed to fetch voter');
        }
        const data = await res.json();
        setVoter(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchVoter();
  }, [voterId]);

  if (loading) return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <Navbar />
      <div style={{ display: 'flex', maxWidth: '1000px', margin: '8px auto' }}>
        <AdminSidebar />
        <main style={{ flex: 1, padding: '12px' }}>Loading voter details...</main>
      </div>
    </div>
  );

  if (error) return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <Navbar />
      <div style={{ display: 'flex', maxWidth: '1000px', margin: '8px auto' }}>
        <AdminSidebar />
        <main style={{ flex: 1, padding: '12px' }}>
          <div style={{ color: 'red' }}>{error}</div>
        </main>
      </div>
    </div>
  );

  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return d.toLocaleDateString();
  };

  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <Navbar />
      <div style={{ display: 'flex', maxWidth: '1200px', margin: '8px auto', boxShadow: '0 1px 6px rgba(16,24,40,0.04)' }}>
        <AdminSidebar />
        <main style={{ flex: 1, padding: 12, background: '#fff' }}>
          <h2>Voter Details</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '12px' }}>
            <div><strong>VoterID:</strong> {voter.VoterID}</div>
            <div><strong>CountyCode:</strong> {voter.CountyCode}</div>
            <div><strong>LastName:</strong> {voter.LastName}</div>
            <div><strong>Suffix:</strong> {voter.Suffix}</div>
            <div><strong>FirstName:</strong> {voter.FirstName}</div>
            <div><strong>MiddleName:</strong> {voter.MiddleName}</div>
            <div><strong>Exempt:</strong> {voter.Exempt}</div>
            <div><strong>Addr1:</strong> {voter.Addr1}</div>
            <div><strong>Addr2:</strong> {voter.Addr2}</div>
            <div><strong>City:</strong> {voter.City}</div>
            <div><strong>State:</strong> {voter.State}</div>
            <div><strong>Zip:</strong> {voter.Zip}</div>
            <div><strong>MailAddr1:</strong> {voter.MailAddr1}</div>
            <div><strong>MailAddr2:</strong> {voter.MailAddr2}</div>
            <div><strong>MailAddr3:</strong> {voter.MailAddr3}</div>
            <div><strong>MailCity:</strong> {voter.MailCity}</div>
            <div><strong>MailState:</strong> {voter.MailState}</div>
            <div><strong>MailZip:</strong> {voter.MailZip}</div>
            <div><strong>MailCountry:</strong> {voter.MailCountry}</div>
            <div><strong>Gender:</strong> {voter.Gender}</div>
            <div><strong>Race:</strong> {voter.Race}</div>
            <div><strong>DOB:</strong> {formatDate(voter.DOB)}</div>
            <div><strong>RegDate:</strong> {formatDate(voter.RegDate)}</div>
            <div><strong>Party:</strong> {voter.Party}</div>
            <div><strong>Pre:</strong> {voter.Pre}</div>
            <div><strong>PreGroup:</strong> {voter.PreGroup}</div>
            <div><strong>PreSplit:</strong> {voter.PreSplit}</div>
            <div><strong>PreSuffix:</strong> {voter.PreSuffix}</div>
            <div><strong>VoterStatus:</strong> {voter.VoterStatus}</div>
            <div><strong>ConDist:</strong> {voter.ConDist}</div>
            <div><strong>HouDist:</strong> {voter.HouDist}</div>
            <div><strong>SenDist:</strong> {voter.SenDist}</div>
            <div><strong>CCDist:</strong> {voter.CCDist}</div>
            <div><strong>SBDist:</strong> {voter.SBDist}</div>
            <div><strong>PhArea:</strong> {voter.PhArea}</div>
            <div><strong>PhNum:</strong> {voter.PhNum}</div>
            <div><strong>PhExt:</strong> {voter.PhExt}</div>
            <div><strong>Email:</strong> {voter.Email}</div>
            <div><strong>ZIP4:</strong> {voter.ZIP4}</div>
            <div><strong>LAT:</strong> {voter.LAT}</div>
            <div><strong>LON:</strong> {voter.LON}</div>
            <div><strong>COUNTYID:</strong> {voter.COUNTYID}</div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default VoterDetails;